var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "section mb-0" },
    [
      _vm.title
        ? _c("div", { staticClass: "section-title" }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
            _c("hr")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("date-picker", {
        attrs: {
          value: _vm.day,
          disabledDates: _vm.disabledDates,
          "full-month-name": true,
          maximumView: "day",
          language: _vm.ptBR,
          format: "dd MMMM yyyy",
          placeholder: "selecione um dia"
        },
        on: { selected: _vm.daySelected }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5153a452", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5153a452","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/_Shared/DatePicker.vue
// module id = null
// module chunks = 